exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-b6ed55a4] {\r\n  font-weight: normal;\n}\n.estilo-radio[data-v-b6ed55a4] {\r\n  padding: 5px 8px 0px 8px !important;\n}\n.estilo-buscar[data-v-b6ed55a4] {\r\n  padding: 0px 8px 8px 8px !important;\n}\n.estilo-buscar2[data-v-b6ed55a4] {\r\n  padding: 10px 0 8px !important;\n}\r\n", ""]);

// exports
